import * as React from 'react'
import { Button } from '@mui/material'
import { openInNewTab } from 'shared/utils/fileExport'

interface OpenJsonButtonProps {
  data: object | string
  disabled?: boolean
  buttonText?: string
  filename?: string
}

export function OpenJsonButton({
  data,
  disabled,
  buttonText = 'Open JSON',
  filename,
}: OpenJsonButtonProps) {
  const handleOpenJson = () => {
    // Generate unique filename if not provided
    const uniqueFilename =
      filename ||
      `data-${Date.now()}-${Math.random().toString(36).substring(2, 9)}.json`
    openInNewTab({ data, filename: uniqueFilename })
  }

  return (
    <Button
      variant="text"
      size="small"
      onClick={handleOpenJson}
      disabled={disabled || false}
      sx={{ textTransform: 'none', fontSize: '0.75rem' }}
    >
      {buttonText}
    </Button>
  )
}
